import React from "react";
import styled from "styled-components";
import { Badge } from "./Badge.tsx";

const BadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 240px;
  align-items: center;
`;

const AllButton = styled.button`
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 6px;
  font-size: 11.5px;
  line-height: 18px;
  
  border-radius: 16px;
  background-color: rgba(22, 22, 23, 1);
  color: rgba(124, 128, 134, 1);
  border: none;
    transition: 0.1s;
    &:hover { 
     background-color: rgba(33, 32, 32, 1);
     transition: 0.1s;
    }

  cursor: pointer;
`;

function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';
  for (let i = 0; i < 3; i++) {
    // генерация ярких цветов с контрастом
    const value = ((hash >> (i * 8)) & 0xff) % 128 + 128; // диапазон 128-255
    color += value.toString(16).padStart(2, '0');
  }

  return color;
}
type CountriesProps = {
  countries: string[];
  onAllClick: () => void;
  onCountryClick: (country: string) => void;
};

export const CountryBadges: React.FC<CountriesProps> = ({ countries, onAllClick, onCountryClick }) => {
  const visible = countries.slice(0, 5);
  const hiddenCount = countries.length - visible.length;

  return (
    <BadgesWrapper>
      {visible.map((c, idx) => (
        <Badge onClick={() => onCountryClick(c)} key={idx} label={c} color={stringToColor(c)} />
      ))}
      {hiddenCount > 0 && <AllButton onClick={onAllClick}>Все</AllButton>}
    </BadgesWrapper>
  );
};
